import { safeSession } from '@/utils/safeStorage';

const SESSION_KEY = 'ts_session_id';

/** `s_<13-digit ms>_<uuid>`. The timestamp prefix is what traffic_origin
 * classifies as a browser; the UUID is unguessable. Length stays under 80. */
export function newAnonymousSessionId(): string {
  return `s_${Date.now()}_${crypto.randomUUID()}`;
}

/** Read the tab's session id, minting one when sessionStorage is empty. */
export function ensureAnonymousSessionId(): string {
  const existing = safeSession.get(SESSION_KEY);
  if (existing) return existing;
  const sid = newAnonymousSessionId();
  safeSession.set(SESSION_KEY, sid);
  return sid;
}
